import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Text, Box, Anchor } from "grommet";
import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import * as styled from "styled-components";
import { DefaultSizes } from "../utils/Theme";
const CustomButtonBox = ({ children, disabled, size, ...props }) => {
    return (
        <Box border={{ size: "2px", color: "background-front" }} direction="row" pad={size} {...props} style={{ cursor: disabled ? "not-allowed" : "pointer" }}>
            {children}
        </Box>
    );
};

const CustomButtonLabel = ({ children, disabled, size, ...props }) => {
    return (
        <Text color={disabled ? "background-front" : "text"} {...props} style={{ whiteSpace: "nowrap" }} size={size || "medium"}>
            {children}
        </Text>
    );
};

const CustomButton = ({
    href,
    path,
    icon,
    label,
    onClick,
    primary,
    color,
    loading,
    disabled,
    size,
    ...props
}: {
    href?: string;
    path?: string;
    icon?: ReactElement | HTMLElement;
    label?: ReactElement | string | HTMLElement;
    onClick?: (...args: any[]) => any;
    primary?: boolean;
    color?: string;
    loading?: boolean;
    disabled?: boolean;
    [x: string]: any;
}) => {
    let background = "";
    let hoverIndicator = "background-front";

    if (primary) {
        background = "background-front";
        hoverIndicator = "background-back";
    }

    if (color) {
        background = color;
        hoverIndicator = "background-back";
    }

    const spaceSize = !!size ? DefaultSizes[(Math.max(DefaultSizes.indexOf(size)) - 1, 0)] : "small";

    if (path)
        return (
            <Link to={!disabled ? path : ""} style={{ textDecoration: "none", color: "unset" }} {...props}>
                <CustomButtonBox
                    size={spaceSize}
                    disabled={disabled}
                    hoverIndicator={!disabled && hoverIndicator}
                    background={disabled ? "background" : background}
                    onClick={() => {}}
                    round="5px"
                    justify="center"
                >
                    <Box direction="row" gap={"small"} align="center">
                        {loading ? <FontAwesomeIcon icon={["fad", "spinner-third"]} spin></FontAwesomeIcon> : icon}
                        {label && (
                            <CustomButtonLabel disabled={disabled} size={size}>
                                {label}
                            </CustomButtonLabel>
                        )}
                    </Box>
                </CustomButtonBox>
            </Link>
        );
    if (onClick)
        return (
            <Box {...props}>
                <CustomButtonBox
                    size={spaceSize}
                    disabled={disabled}
                    border={{ size: "2px", color: "background-front" }}
                    direction="row"
                    pad={"small"}
                    hoverIndicator={!disabled && hoverIndicator}
                    background={disabled ? "background" : background}
                    onClick={() => !disabled && onClick()}
                    justify="center"
                    round="5px"
                >
                    <Box direction="row" gap={"small"} align="center">
                        {loading ? <FontAwesomeIcon icon={["fad", "spinner-third"]} spin></FontAwesomeIcon> : icon}
                        {label && (
                            <CustomButtonLabel disabled={disabled} size={size}>
                                {label}
                            </CustomButtonLabel>
                        )}
                    </Box>
                </CustomButtonBox>
            </Box>
        );
    if (href) {
        return (
            <Anchor href={path} style={{ textDecoration: "none", color: "unset" }} {...props} disabled={disabled}>
                <CustomButtonBox
                    size={spaceSize}
                    disabled={disabled}
                    border={{ size: "2px", color: "background-front" }}
                    direction="row"
                    pad={"small"}
                    hoverIndicator={!disabled && hoverIndicator}
                    background={disabled ? "background" : background}
                    onClick={() => {}}
                    round="5px"
                    justify="center"
                >
                    <Box direction="row" gap={"small"} align="center">
                        {loading ? <FontAwesomeIcon icon={["fad", "spinner-third"]} spin></FontAwesomeIcon> : icon}
                        {label && (
                            <CustomButtonLabel disabled={disabled} size={size}>
                                {label}
                            </CustomButtonLabel>
                        )}
                    </Box>
                </CustomButtonBox>
            </Anchor>
        );
    }
    return (
        <Box {...props} round="5px">
            <CustomButtonBox
                size={spaceSize}
                disabled={disabled}
                border={{ size: "2px", color: "background-front" }}
                direction="row"
                pad={"small"}
                justify="center"
                background={primary ? "background-back" : ""}
            >
                <Box direction="row" gap={"small"} align="center">
                    {icon}
                    {label && (
                        <CustomButtonLabel disabled={disabled} size={size}>
                            {label}
                        </CustomButtonLabel>
                    )}
                </Box>
            </CustomButtonBox>
        </Box>
    );
};

export default CustomButton;
